import { createFileRoute } from '@tanstack/react-router';
import LogTemplates from '../../../features/baseData/logTemplates/logTemplates';
import {
  createPermissionGuard,
  getPermissionSet,
  LOG_TEMPLATES_PERMISSIONS,
} from '@bmwe/ui';

export const Route = createFileRoute('/stammdaten/verfuegungsvorlagen/')({
  component: LogTemplates,
  beforeLoad: createPermissionGuard(
    getPermissionSet(LOG_TEMPLATES_PERMISSIONS, 'READ'),
  ),
});

export const ListLogTemplatesRoute = Route;
